import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { TwoDecimalNumberDirective } from './_directives/twoDecimalNumber.directive';
import { MaxLengthDirective } from './_directives/max-length/max-length.directive';
import { AppSignaturePadComponent } from './components/shared/signature-pad/signature-pad.component';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import { AlertModule } from 'ngx-bootstrap/alert';
import { RouterModule } from '@angular/router';
import { CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';

@NgModule({
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
    imports: [
        FormsModule,
        CommonModule, // Required for ngClass
        AppSignaturePadComponent,
        TwoDecimalNumberDirective,
        MaxLengthDirective,
        ReactiveFormsModule,
        InfiniteScrollModule,
        AlertModule,
        RouterModule
    ],
    exports: [
        FormsModule,
        CommonModule, // Required for ngClass
        AppSignaturePadComponent,
        TwoDecimalNumberDirective,
        MaxLengthDirective,
        ReactiveFormsModule,
        InfiniteScrollModule,
        AlertModule,
        RouterModule
    ]
})
export class SharedModule { }